import { render, staticRenderFns } from "./CollapseIndicator.vue?vue&type=template&id=f4b2e6bc&scoped=true&"
import script from "./CollapseIndicator.vue?vue&type=script&lang=ts&"
export * from "./CollapseIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./CollapseIndicator.vue?vue&type=style&index=0&id=f4b2e6bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b2e6bc",
  null
  
)

export default component.exports